import React, { useEffect, useState } from 'react';

import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { Space } from 'components/barbr';
import { LocationIcon, ShopIcon, TimeIcon } from 'components/Icon';
import Accordion from 'react-bootstrap/Accordion';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getProfileRoute } from 'appRoutes/routeHelpers';
import { isEmpty, isObject } from '_dash';
import { getMapLink, getScheduleItem } from 'utils';

import ProfileSchedule from '../../components/schedule';

import './style.scss';

dayjs.extend(customParseFormat);

const MobileProfileAddress = ({ shop, address, schedules }) => {
  const todayDay = dayjs().format('dddd');
  const [daySchedule, setDaySchedule] = useState({});

  useEffect(() => {
    setDaySchedule(schedules.find((item) => item.day_of_week === todayDay));
  }, [schedules, todayDay]);

  return (
    <div className='section barber-profile-address'>
      <If condition={shop}>
        <Space size={12} className='mb-12'>
          <ShopIcon />
          <p className='flex-fill'>{shop.name}</p>
          <Link to={getProfileRoute(shop.username)}>View</Link>
        </Space>
      </If>
      <Space size={12} className='mb-12'>
        <LocationIcon />
        <p className='flex-fill'>{address.display_name || address.formatted_name}</p>
        <a target='_blank' rel='noreferrer' href={getMapLink(address.formatted_name)}>
          Map
        </a>
      </Space>
      <Accordion>
        <Accordion.Item eventKey='schedule'>
          <Accordion.Header>
            <Space size={12}>
              <TimeIcon />
              <Choose>
                <When condition={isObject(daySchedule) && !isEmpty(daySchedule)}>
                  <p>{getScheduleItem(daySchedule)}</p>
                </When>
                <When condition={!isObject(daySchedule)}>
                  <p>Closed</p>
                </When>
              </Choose>
            </Space>
          </Accordion.Header>
          <Accordion.Body>
            <ProfileSchedule schedules={schedules} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default MobileProfileAddress;
